'use client'
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/layout';
import { FormControl, FormErrorMessage, FormLabel, Input, Button } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/button';
import { MdCheck } from 'react-icons/md';
import { forwardRef } from '@chakra-ui/system';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import { AuthContext } from '@/auth/lib/authContext';
import useTranslation from '../../../lib/i18n/useTranslation';
const NewExperienceInSharedExperienceForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    sharedExperienceId,
    groupId,
    objectiveDefault
  } = props;
  const { profile } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    formState: { isSubmitting, isValid }
  } = useForm({
    mode: "onChange"
  });
  const experienceApi = useExperienceApi();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const objective = data.objective;
      let newExperience;
      if (objective) {
        newExperience = await experienceApi.insertExperience(objective);
        if (newExperience && newExperience.id) {
          if (groupId) {
            await sharedExperiencesApi.addExperience(sharedExperienceId, newExperience.id, groupId);
          } else {
            await sharedExperiencesApi.addExperience(sharedExperienceId, newExperience.id);
          }
        }
      }
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error('Error in newExperienceInSharedExperienceForm:', e);
    }
  };
  useEffect(() => {
    if (objectiveDefault) {
      setValue('objective', objectiveDefault);
    }
  }, [objectiveDefault, setValue]);
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <FormControl isInvalid={errors && errors.objective} mb={3}>
          <FormLabel>{t('experience.objective')}</FormLabel>
          <Input
            placeholder={t('experience.experiencePlaceholder')}
            {...register('objective', { required: "Please enter an objective" })}
          />
          <FormErrorMessage>{errors && errors.objective}</FormErrorMessage>
        </FormControl>
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});
export default NewExperienceInSharedExperienceForm; 